import React from "react"

import Profile from "@/components/AccountSettings/v1/Profile"
import Addresses from "@/components/AccountSettings/v1/Addresses"
import LoginSecurity from "@/components/AccountSettings/v1/LoginSecurity"
import Communication from "@/components/AccountSettings/v1/Communication"
import AccountManagement from "@/components/AccountSettings/v1/AccountManagement"
import AccountsLayout from "@/components/AccountsLayout/AccountsLayout"

import accountSettingsStyle from "@/components/AccountSettings/v1/AccountSettingsView/index.module.scss"

const AccountSettingsView = ({
  i18n = {},
  profile = {},
  data = [],
  subscriptionPath = "",
  redirect = () => {},
  logout = () => {},
  businessList = [],
  redirectToHome = () => {},
  ...restProps
}) => {
  return (
    <div className={`${accountSettingsStyle?.accountSettingsStyleWrapper}`}>
      <div className={`account-settings`}>
        <AccountsLayout
          title={i18n?.accountSettings}
          user={profile}
          activeTab={0}
          i18n={i18n}
          data={data}
          redirect={redirect}
          logout={logout}
        >
          <Profile
            i18n={i18n}
            data={profile}
            businessList={businessList}
            {...restProps}
          />
          <Addresses i18n={i18n} data={profile} {...restProps} />
          <LoginSecurity
            i18n={i18n}
            data={profile}
            redirectToHome={redirectToHome}
            logout={logout}
            {...restProps}
          />
          <Communication
            i18n={i18n}
            subscriptionPath={subscriptionPath}
            {...restProps}
          />
          <AccountManagement i18n={i18n} {...restProps} />
        </AccountsLayout>
      </div>
    </div>
  )
}

export default AccountSettingsView
